import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CDSNav } from "@ciscodesignsystems/cds-react-nav";
import { DESIGN_API, ON_BOARD, OVERVIEW, REVIEW_SPEC } from "../app/paths";

const navItems = [
  { id: "overview", label: "Overview", path: OVERVIEW, icon: "home" },
  { id: "design-api", label: "Design API", path: DESIGN_API, icon: "design" },
  { id: "review-spec", label: "Review Spec", path: REVIEW_SPEC, icon: "documentation" },
  { id: "on-board", label: "Onboard", path: ON_BOARD, icon: "submit" },
];

const LeftNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <CDSNav
      className={`uag-nav ${isCollapsed ? "uag-nav--collapsed" : "uag-nav--expanded"}`}
      aria-label="Primary"
      isCollapsed={isCollapsed}
      setCollapsed={setIsCollapsed}
      collapseButtonProps={{
        "aria-label": "Toggle navigation",
        tooltip: "Toggle navigation",
      }}
    >
      <CDSNav.Section>
        {navItems.map((item) => (
          <CDSNav.Item
            key={item.id}
            id={item.id}
            icon={item.icon}
            isSelected={pathname === item.path}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </CDSNav.Item>
        ))}
      </CDSNav.Section>
    </CDSNav>
  );
};

export default LeftNav;
